import React, { useEffect, useState } from "react";

import "../appointment/style.css";
import "./style.css";
import { useNavigate } from "react-router-dom";
import {
  deleteSessionNote,
  deleteSessionService,
  getActiveMembers,
  getActiveProgramById,
  inviteMembers,
  putSIngleActiveSession,
  updateActiveProgramById,
} from "../../services/ActivePrograms";
import GroupActivityButton from "../groups/ui/GroupActivityButton";
import PlusSvg from "../../svg/NewPlusSvg.svg";
import TimerSolidSvg from "../../svg/TimerSolidSvg.svg";
import CopyIconSvg from "../../svg/CopYIconSvg.svg";

import { FiVideo } from "react-icons/fi";
import { format, formatDistance, getDate, parseISO } from "date-fns";
import { BsShare, BsTrashFill } from "react-icons/bs";
import moment from "moment";
import Popup from "../../commonComponent/Popup";
import Button from "../../commonComponent/Button";
import DateInput from "../../commonComponent/CutomDatePicker";
import {
  checkEndDate,
  dateSort,
  formatAMPM,
  onStartSession,
  showToastError,
  showToastSuccess,
} from "../../Utils/Helper";
import { createZoomMeetingService } from "../../services/ZoomService";
import { getAvailableSessionSlots } from "../../services/DoctorService";
import { AiFillEdit, AiFillPlusCircle, AiOutlineStop } from "react-icons/ai";
import DeleteModal from "../../commonComponent/DeleteModal";
import { ImBlocked, ImStopwatch } from "react-icons/im";
import ActiveMemberModal from "./ActiveMemberModal";
import AddEditNotesModal from "./AddEditNotesModal";
import DurationSvg from "../../svg/DurationAddSession.svg";
import ViewMemberListSession from "./ViewMemberListSession";
import { FaClock, FaCopy, FaPlay, FaRegEdit, FaStickyNote } from "react-icons/fa";
import { useAuth } from "../../Context/AuthContext";
import ShareLinkModal from "../carePlan_/ShareLinkModal";
import ButtonWithIcon from "../../commonComponent/ButtonWithIcon";
import { IoIosAlarm } from "react-icons/io";

const ViewSessionDetails = ({
  state,
  content,
  notes,
  getSessionNotes,
  getSessionById,
  setIsClickedAddNotes
}) => {
  const navigate = useNavigate();
  const auth = useAuth();

  const [Operation, setOperation] = useState("add");
  const [modalShow, setModalShow] = useState(false);
  const [memberList, setMemberList] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [sessionStartTime, setSessionStartTime] = useState();
  const [sessionEndTime, setSessionEndTime] = useState("");
  const [sessionTitle, setSessionTitle] = useState("");
  const [sessionDescription, setSessionDescription] = useState("");
  const [sessionDate, setSessionDate] = useState(new Date(state.sessionDate));
  const [noteData, setNoteData] = useState();
  const [dropDown, setDropDown] = useState(false);
  const [open, setOpen] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [ProgramDetails, setProgramDetails] = useState({});
  const [Duration, setDuration] = useState();
  const [SessionDuration, setSessionDuration] = useState("");

  const [timeList, setTimeList] = useState([]);
  const [sessionId, setSessionId] = useState("");
  const [zoomlink, setZoomlink] = useState(false);
  const [meetLocation, setMeetLocation] = useState(state?.sessionLink_doctor);

  const [formValues, setFormValues] = useState([
    { email: "", first_name: "", last_name: "" },
  ]);

  console.log(state);

  const deleteNote = async (pid, sid, shareNoteId) => {
    let parms = {};
    parms["programId"] = pid;
    parms["sessionId"] = sid;
    parms["shareNoteId"] = shareNoteId;

    try {
      const response = await deleteSessionNote(parms);
      if (response.status === 200) {
        showToastSuccess(`Deleted`);
        getSessionNotes();
      } else {
        showToastError(`Error Ocurred`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getMembersById = async (searchWord) => {
    try {
      const response = await getActiveMembers(state?.programId, searchWord);
      // setLoader(false);
      if (response.status === 200) {
        console.log(response.data.data, "membersss");
        setMemberList(response?.data?.data[0]?.programMembers ?? []);
      } else {
        console.log(response?.data || response.message);
      }
    } catch (error) {
      // setLoader(false);
      error?.data?.data &&
        console.log(error?.data?.data || error.data?.message);
    }
  };

  const getProgram = async () => {
    try {
      const res = await getActiveProgramById(state?.programId);
      console.log(res?.data?.data[0]);
      setProgramDetails(res?.data?.data[0]);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getProgram();
    getDuration();
    getMembersById();
    const diff =
      new Date(state.endTime).getTime() - new Date(state.startTime).getTime();
    setDuration(diff / 60000);
    setSessionEndTime(state.endTime);
    setSessionStartTime(state.startTime);
    setSessionTitle(state.title);
    setSessionDescription(state.description);
    getSessionNotes();

  }, [state?.programId]);

  useEffect(() => {
    if (
      Duration == "30" ||
      Duration == "60" ||
      Duration == "90" ||
      Duration == "120"
    ) {
      getTimeSlots(format(sessionDate, "yyyy-MM-dd"));
    }
  }, [Duration, sessionDate]);

  const deleteSession = async (sessionId) => {
    try {
      const response = await deleteSessionService(state._id, state.programId);
      if (response) {
        showToastSuccess(response?.data || "Session deleted successfully.");
        // getSessionById();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };
  const canStartSession = !checkEndDate(sessionDate);

  const getTimeSlots = async (date) => {
    try {
      const response = await getAvailableSessionSlots(date, Duration);
      if (response.status === 200) {
        console.log(response.data.data, "booking data");
        let listOfTime = dateSort(response?.data?.data);
        console.log(listOfTime);
        setTimeList(
          response.data.data.length > 0 ? dateSort(response?.data?.data) : []
        );
      } else {
        alert(response?.data || response.message);
      }
      // setLoader(false);
    } catch (error) {
      error?.data?.data && alert(error?.data?.data || error.data?.message);
    }
  };
  // console.log(notes);
  const drop = `dropdown-menu${dropDown ? " show" : ""}`;

  // console.log(timeList);
  // const handleSubmitGoal = (e) => {
  //   e.preventDefault();
  //   setPostData({
  //     name: e.target.elements.title.value,
  //     description: e.target.elements.description.value,
  //     sessionDate: sessionDate,
  //   });
  // };

  const createMeeting = async () => {
    try {
      // if (sessionApiChange == "edit") {
      const meetingDetail = {
        topic: ProgramDetails?.programName,
        type: 8,
        start_time: state.startTime,
        duration: "60",
        recurrence: {
          end_date_time: state.endTime,
          monthly_week: 1,
          monthly_week_day: 1,
          repeat_interval: 2,
          type: 2,

          // "weekly_days": weekDay[sessionWeeks],
        },
        settings: {
          host_video: true,
          participant_video: true,
          join_before_host: true,
          mute_upon_entry: "true",
          watermark: "true",
          audio: "voip",
          auto_recording: "cloud",
          email_notification: true,
          registrants_email_notification: true,
        },
      };

      const meetingResponse = await createZoomMeetingService(meetingDetail);
      if (meetingResponse) {
        return meetingResponse;
      }
    } catch (error) {
      if (error?.data?.data) {
        navigate("/myprofile");
        showToastError(
          error?.data?.data || error.data?.message || "Some error occurred"
        );
      }
    }
  };

  const handleSubmitSession = async (e) => {
    // const sessionTimeEdit = sessionTime.split(" ");

    e.preventDefault();
    // if (!checkValidation()) {
    //   return;
    // }
    // setSubmit(true);
    // const sessionD = session.toString();
    try {
      const sessionD = format(sessionDate, "yyyy-MM-dd");
      var parms = {
        programId: ProgramDetails._id,
        title: sessionTitle,
        sessionDate: sessionD,
        startTime: sessionStartTime,
        endTime: sessionEndTime,
        description: sessionDescription,
        // "session_timezone": sessionTimeZone,
        sessionLink_doctor: meetLocation,
        sessionLink_user: meetLocation,
        sessionId: state._id,
      };
      if (zoomlink) {
        const meetingResponse = await createMeeting();
        parms.sessionLink_doctor = meetingResponse.start_url;
        parms.sessionLink_user = meetingResponse.join_url;
      }
      const response = await putSIngleActiveSession(parms);
      if (response.status === 200) {
        getDuration(sessionStartTime, sessionEndTime);
        showToastSuccess(`Active session is updated`);
        getProgram();
        getSessionById();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      // setShowLoader(false)
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };


  const getDuration = (start = state?.startTime, end = state?.endTime) => {
    const dur = start && end && formatDistance(parseISO(start), parseISO(end));
    setSessionDuration(dur);
    setDuration(dur);
  };

  let cstTime = new Date(state.startTime).toLocaleString("es-MX", {
    timeZone: "America/Mexico_City",
  });
  console.log(cstTime);

  let handleMember = async () => {
    var parms = {};
    parms["EmailList"] = selectedMembers.map((dt) => {
      return { name: dt.name, email: dt.email };
    });

    try {
      const response = await inviteMembers(parms);
      // setAskLoader(false)
      if (response.status === 200) {
        updateProgram(response?.data?.data);
        showToastSuccess("Invite sent successfully");
        console.log(response.data.data, "response data");

        setFormValues([{ email: "", first_name: "", last_name: "" }]);
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      // setAskLoader(false)
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  const updateProgram = async (programMembers) => {
    // setLoader(true)
    try {
      const fileName = ProgramDetails.programImage.split("/");
      const imageName = fileName[fileName.length - 1];
      const response = await updateActiveProgramById(ProgramDetails._id, {
        ...ProgramDetails,
        programImage: imageName,
        programMembers: programMembers,
        careTeam: ProgramDetails.careTeam,
        programName: ProgramDetails.programName,
        programType: ProgramDetails.programType,
        price: ProgramDetails.price,
        description: ProgramDetails.description,
        startDate: ProgramDetails.startDate,
        endDate: ProgramDetails.endDate,
        status: ProgramDetails.status,
      });
      getMembersById();
      if (response.status === 200) {
        showToastSuccess("Members Assigned Successfully");
        getMembersById();
      }
    } catch (error) {
      console.log(error);
    }
  };

  console.log(sessionDate,state?.sessionDate);
  return (
    <>
      <div className="row ">
        <div className="col-12 my-3">
          {content}
        </div>
        <div className="col-12 d-flex align-items-center">
        
          <h4 className="me-4 p-0 m-0">Session Details </h4>
          <button
            type="button"
            className="btn btn-sm"
            style={{ color: "rgba(21, 101, 99, 1)" ,fontSize:"20px"}}
          >
            <IoIosAlarm  />
          </button>
          <button
            type="button"
            className="btn btn-sm"
            style={{ color: "rgba(21, 101, 99, 1)" ,fontSize:"20px"}}
            onClick={() => setShowPopup(true)}
          >
            <AiFillEdit />
          </button>
        </div>
        <div className="col-12  mt-4 d-flex align-items-center justify-content-between">
          <div>
            <h5 className="fw-normal">
              {" "}
              {state?.sessionDate &&
                moment(sessionDate).format("dddd, MMM DD yyyy")}{" "}
            </h5>
            <h4 className="fw-semibold mt-3"> {sessionTitle} </h4>
          </div>
          <div className=""> 
            <h5 className="fw-normal d-flex align-items-center justify-content-end">
              
              <FaClock style={{color:"rgba(31, 126, 120, 1)"}} className="me-2 " size={"17px"} /> 
              {/* <img src={TimerSolidSvg} alt="" />{" "} */}
              {state?.startTime && format(parseISO(state?.startTime), "HH:MM")}{" "}
              CST{" "}
            </h5>
            <h5 className="fw-normal mt-3"> Duration : {SessionDuration} </h5>
          </div>
        </div>
        <div className="col-12 mt-2">
          <p> {state?.description} </p>
        </div>
        <div className="col-12 mt-2 d-flex gap-5 ">
          <button
            type="button"
            style={{backgroundColor:"rgba(31, 126, 120, 1)",border:"none",color:"white"}}
            className="btn py-2 fw-medium"
            onClick={() => onStartSession(state?.sessionLink_doctor)}
          >
           <div className="d-flex justify-content-start align-items-center ">
              <FaPlay fill="white" className="me-2" size={"16px"} />
              Join Session
            </div>
          </button>
      
          <ButtonWithIcon
            style={{fontSize:"16px"}}
            className="btn btn-lisgh rounded py-2 px-3 text-center fw-medium cancel-btn"
            
            onClick={() => {
              setSessionId(state._id);
            }}
            icon={<ImBlocked  className="mx-2" size={"16px"} />}
            label="Cancel Session"
             data-bs-toggle="modal"
            data-bs-target="#deleteSession"
          />

          <ButtonWithIcon
            style={{fontSize:"16px"}}
            className="btn btn-light rounded py-2 px-3 text-center fw-medium"
            onClick={() => {
              setIsClickedAddNotes(true)
            }}
            icon={<FaStickyNote  className="mx-2" size={"16px"} />}
            label="Session Notes"
          />
          <button
            type="button"
            onBlur={() => {
              setDropDown(false);
            }}
            onClick={() => {
              setDropDown(!dropDown);
            }}
            className="btn btn-primary btn-custom-tag py-2"
          >
            <div
              className="pointer d-flex gap-1 align-items-center me-3"
             
            >
              <AiFillPlusCircle color="rgba(31, 126, 120, 1)" size="18px" />
              <a
                className="fw-semibold text-decoration-none "
                style={{
                  color: "rgba(31, 126, 120, 1)",
                }}
              >
                <span
                  style={{ fontSize: "16px" }}
                  className="position-relative "
                >
                  Invite Member
                  <ul
                    className={drop + " top-0 start-0 w-100"}
                    style={{ marginTop: "2em" }}
                  >
                    <li>
                      <a
                        className="dropdown-item pointer"
                        data-bs-toggle="modal"
                        data-bs-target="#memberModal"
                      >
                        Add new
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item pointer"
                        onClick={() => setOpen(true)}
                        data-bs-toggle="modal"
                        data-bs-target="#addmembermodal1"
                      >
                        Add my client
                      </a>
                    </li>
                  </ul>
                </span>
              </a>
            </div>
          </button>
          <DeleteModal
            title={"Delete"}
            content1={"Are you sure you want to delete"}
            content2={"this Session?"}
            modalId={"deleteSession"}
            button2={"No"}
            button1={"Yes"}
            onDelete={() => deleteSession(sessionId)}
          />
        </div>

        <div className="col-8 mt-4" >
          
          {/* <div
            className="col-12 my-3"
            style={{ fontSize: "24px", color: "rgba(47, 156, 149, 1)" }}
          >
            {sessionTitle} <span>(Video Call)</span>
          </div> */}
          {/* <div className="col-12 my-3 d-flex gap-2 align-items-center ">
            <span style={{ fontSize: "20px", color: "rgba(87, 87, 87, 1)" }}>
              Duration : {SessionDuration}{" "}
            </span>
            <ImStopwatch
              style={{
                fontSize: "20px",
                color: "rgba(21, 101, 99, 1)",
                backgroundClip: "content-box",
              }}
            />
          </div>
          <div className="col-12 mt-3 mb-4">
            <GroupActivityButton
              padding="5px 15px"
              backgroundColor="#F4F4F4"
              color="rgba(31, 126, 120, 1)"
              border="2px solid rgba(31, 126, 120, 1)"
              borderRadius="50px"
              className="fw-semibold "
            >
              Set Reminder
            </GroupActivityButton>
          </div> */}
          {/* <div
            className="col-12 px-2 pt-2 d-flex flex-column justify-content-between gap-3 rounded-2 "
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <label htmlFor="" className="mt-1">
              Program
            </label>
            <p
              className="fw-semibold "
              style={{ fontSize: "20px", color: "rgba(31, 126, 120, 1)" }}
            >
              {ProgramDetails.programName}
            </p>
          </div> */}
          {/* <div
            className="col-12 mt-3 px-2 pt-2 d-flex flex-column justify-content-between gap-3 rounded-2 "
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <label htmlFor="">Duration</label>
            <p
              style={{ fontSize: "20px", color: "rgba(31, 126, 120, 1)" }}
              className="fw-semibold"
            >
              {SessionDuration}
            </p>
          </div> */}
          <div className="col-12 ">
            <h3 style={{ fontSize: "22px" }}>Meeting Link</h3>
            <div
              className="col-12 pb-3 pt-2 d-flex flex-column justify-content-between gap-3 rounded-2 "
             
            >
              <label htmlFor="" className="col-12">
                Join Link (Meeting ID :{" "}
                {state?.sessionLink_doctor.slice(26, 37)})
              </label>
              <div className="row">
                <div
                  className="col-10"
                  style={{
                    fontSize: "18px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <a
                    href={!zoomlink ? meetLocation : state?.sessionLink_doctor}
                    style={{ color: "rgba(31, 126, 120, 1)" }}
                    className="pointer text-decoration-none  fw-semibold"
                  >
                    {!zoomlink ? meetLocation : state?.sessionLink_doctor}
                  </a>
                </div>
                <div className="col-2 d-flex gap-3 align-items-center justify-content-end ">
                  <div className=" pointer">
                    <img
                      height="25px"
                      src={CopyIconSvg}
                      alt=""
                      onClick={() => {
                        navigator.clipboard.writeText(
                          state?.sessionLink_doctor
                        );
                        showToastSuccess("Link/Location Copied");
                      }}
                    />
                  </div>
                  <div className=" pointer">
                    <BsShare
                      data-bs-toggle="modal"
                      data-bs-target="#shareModal"
                      color="rgba(31, 126, 120, 1)"
                      size={"18px"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 mt-4 mb-2 ">
            <h3 style={{ fontSize: "22px" }}>Booking Updates</h3>
            <div
              className="d-flex justify-content-start gap-2 align-items-center pointer my-2"
              onClick={() => {
                setModalShow(true);
                setNoteData(null);
                setOperation("add");
              }}
            >
              <img
                className=""
                style={{ borderRadius: "50%" }}
                src={PlusSvg}
                alt=""
              />
              <span
                href=""
                className="fst-italic mb-2"
                style={{ fontSize: "20px" }}
              >
                Attach note to program invite
              </span>
            </div>
            <div
              className="col-12  d-flex flex-column justify-content-between gap-2 "
              
            >
              {notes == undefined
                ? state?.SharedNotes?.map((note) => {
                    return (
                      <>
                        <div style={{ backgroundColor: "#F4F4F4" }} key={note.shareNoteId} className="rounded-2 p-3">
                          <div className="d-flex justify-content-between ">
                            <div htmlFor="" className="pb-0 fst-italic ">
                              {note?.date &&
                                format(parseISO(note?.date), "MMM d, yyyy")}
                            </div>
                            <div className="d-flex align-items-center gap-4">
                              <AiFillEdit
                                className="pointer"
                                color="rgba(31, 126, 120, 1)"
                                onClick={() => {
                                  console.log(note);
                                  setOperation("edit");
                                  setNoteData(note);
                                  setModalShow(true);
                                }}
                              />
                              <BsTrashFill
                                className="pointer"
                                color="rgba(31, 126, 120, 1)"
                                data-bs-toggle="modal"
                                data-bs-target={
                                  "#deleteNote" + note.shareNoteId
                                }
                              />
                              <DeleteModal
                                modalId={"deleteNote" + note.shareNoteId}
                                onDelete={() => {
                                  deleteNote(
                                    ProgramDetails._id,
                                    state._id,
                                    note.shareNoteId
                                  );
                                }}
                                title={note?.notTitle}
                                onCancel={() => {}}
                                content1="Are you sure?"
                                content2="Do you really want to delete this note?"
                                button1="yes"
                                button2="cancel"
                              />
                            </div>
                          </div>
                          <div
                            className="fw-semibold"
                            style={{
                              fontSize: "18px",
                              color: "rgba(31, 126, 120, 1)",
                            }}
                          >
                            {note?.noteDescription}
                          </div>
                        </div>
                      </>
                    );
                  })
                : notes?.SharedNotes?.map((note) => {
                    return (
                      <>
                        <div style={{ backgroundColor: "#F4F4F4" }}  key={note.shareNoteId} className="col-12 rounded-2 px-3 py-2">
                          <div className="d-flex justify-content-between ">
                            <div htmlFor="" className="pb-0 fst-italic">
                              {note?.date &&
                                format(parseISO(note?.date), "MMM d, yyyy")}
                            </div>
                            <div className="d-flex align-items-center gap-3">
                              <AiFillEdit
                                className="pointer "
                                color="rgba(31, 126, 120, 1)"
                                onClick={() => {
                                  console.log(note);
                                  setOperation("edit");
                                  setNoteData(note);
                                  setModalShow(true);
                                }}
                              />
                              <BsTrashFill
                                className="pointer"
                                color="rgba(31, 126, 120, 1)"
                                data-bs-toggle="modal"
                                data-bs-target={
                                  "#deleteNote" + note.shareNoteId
                                }
                              />
                              <DeleteModal
                                modalId={"deleteNote" + note.shareNoteId}
                                title={note?.noteTitle}
                                onDelete={() => {
                                  deleteNote(
                                    ProgramDetails._id,
                                    state._id,
                                    note.shareNoteId
                                  );
                                }}
                                onCancel={() => {
                                  console.log(note.shareNoteId);
                                }}
                                content1="Are you sure?"
                                content2="Do you really want to delete this note?"
                                button1="yes"
                                button2="cancel"
                              />
                            </div>
                          </div>
                          <div
                            className="fw-semibold col-12"
                            style={{
                              fontSize: "18px",
                              color: "rgba(31, 126, 120, 1)",
                            }}
                          >
                            {note?.noteDescription}
                          </div>
                        </div>
                      </>
                    );
                  })}
            </div>
          </div>
         
        </div>
        <div className="col-4">
          <div className="row justify-content-center text-start align-content-center ">
            <div className="col-12 my-3 px-2 pt-2 d-flex flex-column justify-content-between ">
              <div className="d-flex justify-content-between px-2">
                <h3 style={{ fontSize: "22px" }} className="m-0">
                  Attendees ({ProgramDetails.programMembers?.length})
                </h3>
              </div>
              <div className="col-12 p-2 ">
                {ProgramDetails.programMemerDetails?.length > 0
                  ? ProgramDetails.programMemerDetails?.map((member) => {
                      return <ViewMemberListSession member={member} />;
                    })
                  : null}
              </div>
            </div>
          </div>
        </div>
        {/* <ActiveSessionModel renderForm={<p className="resFont">Hello</p>} isLoading={false}/> */}
        <Popup
          show={showPopup}
          onHide={() => setShowPopup(false)}
          title={`Edit Session`}
          content={
            <>
              <form onSubmit={handleSubmitSession}>
                <div className="row">
                  <div className="col-md-12">
                    <p className="whole_label resFont">
                      title<span className="text-danger"> *</span>
                    </p>
                    <input
                      name="title"
                      type="text"
                      className="description_inputf mb-4"
                      defaultValue={state.title}
                      onChange={(e) => setSessionTitle(e.target.value)}
                    />
                  </div>

                  <div className="col-md-12">
                    <p className="whole_label resFont">
                      description<span className="text-danger"> *</span>
                    </p>
                    <textarea
                      type="text"
                      name="description"
                      className="description_inputf pt-3 mb-4"
                      style={{ height: "200px" }}
                      maxLength={200}
                      defaultValue={state.title}
                      onChange={(e) => setSessionDescription(e.target.value)}
                    />
                    {/* {renderError("Please enter description", error.descr)} */}
                  </div>
                  <div className="col-md-12">
                    <p className="whole_label resFont">
                      date <span className="small_letter2"></span>
                      <span className="text-danger"> *</span>
                    </p>
                    <DateInput
                      name="sessionDate"
                      value={sessionDate}
                      placeHolder={"Please choose..."}
                      imageStyle={{
                        width: "22px",
                        height: "22px",
                        position: "absolute",
                        borderRadius: "0px",
                        marginBlock: "17px",
                        left: "20px",
                      }}
                      onChangeDate={(date) => {
                        setSessionDate(date);
                        getTimeSlots(format(date, "yyyy-MM-dd"));
                      }}
                      maxDate={getDate(parseISO(ProgramDetails.startDate))}
                      minDate={getDate(parseISO(ProgramDetails.endDate))}
                      inputClassName={
                        "description_inputf d-flex align-items-center"
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <p className="whole_label resFont">
                      Duration <span className="small_letter2"></span>
                      <span className="text-danger"> *</span>
                    </p>
                    <select
                      name=""
                      id=""
                      className="px-3 py-3 description_inputf"
                      style={{ color: "rgba(107, 118, 126, 1)" }}
                      value={Duration || SessionDuration}
                      onChange={(e) => {
                        setDuration(e.target.value);
                        // console.log(e.target.value);
                      }}
                      placeholder="Please Select Duration"
                    >
                      <option value="" disabled selected className="">
                        {" "}
                        <img src={DurationSvg} alt=""></img> Please Select
                        Duration
                      </option>
                      {/* <option value="30">30</option> */}
                      <option value="60">60</option>
                      <option value="90">90</option>
                      <option value="120">120</option>
                    </select>
                    {/* {renderError(
                      "Please select date session",
                      error.sessionDate
                    )} */}
                  </div>
                  <div className="col-md-12">
                    <p className="whole_label resFont">
                      Available<span className="small_letter2"> times: </span>
                    </p>
                    {/* {renderError("Please select session time", error.startTime)} */}
                    <div
                      className="d-flex justify-content-space-between memlist_scroll mt-1 spacing_scroll"
                      style={{ height: 200 }}
                    >
                      <div className="col-md-8">
                        {timeList.length ? (
                          timeList.map((dt, i) => {
                            return (
                              <div
                                key={i}
                                // className={`card mb-2 p-1 ${index == 0 ? "active" : ""}`}
                                className={` px-3`}
                                // style={{ background: "#F2F4F6" }}
                                // onClick={() => {
                                // }}
                                id={i}
                              >
                                <div
                                  style={{
                                    fontSize: "14px",
                                    marginLeft: "-5px",
                                  }}
                                >
                                  <div className="form-group">
                                    <label className="py-2">
                                      <input
                                        type="checkbox"
                                        name="members"
                                        value={sessionStartTime}
                                        checked={
                                          formatAMPM(dt.start) ===
                                          formatAMPM(sessionStartTime)
                                        }
                                        id={"flexCheckDefault"}
                                        onChange={() => {
                                          setSessionStartTime(dt.start);
                                          setSessionEndTime(dt.end);
                                          // setError({ ...error, startTime: false });
                                        }}
                                      />
                                      <span
                                        className="affir_checkbox"
                                        style={{
                                          marginLeft: "8px",
                                          marginRight: "5px",
                                        }}
                                      >
                                        Group Session
                                      </span>

                                      {formatAMPM(dt.start) +
                                        " - " +
                                        formatAMPM(dt.end)}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <p className="resFont">No slots available</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <p className="whole_label resFont my-2">
                      Add Location<span className="text-danger"> *</span>
                    </p>
                    <div className="btn-group margin_top_20">
                      <p className="affir_checkbox">
                        <input
                          type="checkbox"
                          onClick={() => {
                            setZoomlink(!zoomlink);
                            console.log(zoomlink);
                            // setError({ ...error, zoomlink: false });
                          }}
                        />
                      </p>
                      <p
                        className="affir_checkbox"
                        style={{ fontSize: 16, color: "#156563" }}
                      >
                        {"Create zoom meeting link"}
                      </p>
                    </div>
                    <input
                      type="text"
                      disabled={zoomlink}
                      className="description_inputf mb-4"
                      placeholder="Type physical  address or leave blank if online only"
                      value={meetLocation}
                      onChange={(e) => {
                        setMeetLocation(e.target.value);
                        console.log(meetLocation);
                      }}
                    />
                    {/* {renderError("Please enter Zoomlink", error.zoomlink)} */}
                  </div>
                  {/* <div className="col-md-12">
                    <p className="whole_label resFont">
                      Available<span className="small_letter2"> times: </span>
                    </p>
                    <div
                      className="d-flex justify-content-space-between memlist_scroll mt-1 spacing_scroll"
                      style={{ height: 200 }}
                    >
                      <div className="col-md-6">
                        {timeList.length ? (
                          timeList.map((dt, i) => (
                            <div
                              key={i}
                              className={` px-3`}

                              id={i}
                            >
                              <p
                                style={{ fontSize: "14px", marginLeft: "-5px" }}
                              >
                                <div className="form-group">
                                  <label>
                                    <input
                                      type="radio"
                                      name="members"
                                      value={sessionStartTime}
                                      checked={
                                        formatAMPM(dt.start) ===
                                        formatAMPM(sessionStartTime)
                                      }
                                      id={"flexCheckDefault"}
                                      onChange={() => {
                                        setSessionStartTime(dt.start);
                                        setSessionEndTime(dt.end);
                                      }}
                                    />
                                    <span
                                      className="affir_checkbox"
                                      style={{
                                        marginLeft: "8px",
                                        marginRight: "5px",
                                      }}
                                    >
                                      Group Session
                                    </span>
                                  </label>
                                  {formatAMPM(dt.start) +
                                    " - " +
                                    formatAMPM(dt.end)}
                                </div>
                              </p>
                            </div>
                          ))
                        ) : (
                          <p className="resFont">No slots available</p>
                        )}
                      </div>
                    </div>
                  </div> */}
                </div>

                <div className="col-md-12">
                  {/* <hr /> */}
                  <div className="d-flex justify-content-between">
                    <div
                      style={{
                        backgroundColor: "#fff",
                        color: "black",
                        border: "1px solid #bbb9b9",
                      }}
                      onClick={() => {
                        setShowPopup(false);
                      }}
                      className="description_btnsave pointer d-flex justify-content-center align-items-center"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Cancel
                    </div>
                    <Button
                      //   isLoading={isSubmit}
                      //   disabled={isSubmit}
                      onClick={() => {
                        setShowPopup(false);
                      }}
                      text="Save"
                      type="submit"
                      id="reateProgram"
                      className="description_btnsave d-flex justify-content-center align-items-center pointer"
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </form>
            </>
          }
          position="top"
        />
      </div>
      {/* <AddMemberModal
        addMember={updateGroup}
        members={state?.groupMembers}
        setMembers={setSelectedGroupMembers}
      /> */}
      <ShareLinkModal link={state?.sessionLink_doctor} />

      <ActiveMemberModal
        state={state}
        addMember={() => handleMember()}
        open={open}
        setOpen={setOpen}
        members={memberList.map((dt) => dt?._id?._id)}
        setMembers={setSelectedMembers}
        selectedMembers={selectedMembers}
      />
      {noteData ? (
        <AddEditNotesModal
          pid={ProgramDetails._id}
          sid={state?._id}
          show={modalShow}
          data={noteData}
          operation={Operation}
          setNoteData={setNoteData}
          getProgram={getSessionNotes}
          onHide={() => setModalShow(false)}
        />
      ) : (
        <AddEditNotesModal
          pid={ProgramDetails._id}
          sid={state?._id}
          show={modalShow}
          operation={Operation}
          getProgram={getSessionNotes}
          onHide={() => setModalShow(false)}
        />
      )}
    </>
  );
};

export default ViewSessionDetails;
